/**
 * FileNotFoundDialog
 *
 * Alert dialog shown when a script file no longer exists on disk.
 * Offers to remove the entry from the scripts list or keep it.
 */

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../../../components/ui/alert-dialog';
import type { ScriptEntry } from '../types/scriptBrowserTypes';

type FileNotFoundDialogProps = {
  script: ScriptEntry;
  onRemove: () => void;
  onKeep: () => void;
};

export function FileNotFoundDialog({
  script,
  onRemove,
  onKeep,
}: FileNotFoundDialogProps) {
  return (
    <AlertDialog open onOpenChange={(open) => !open && onKeep()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>File not found</AlertDialogTitle>
          <AlertDialogDescription>
            <span className="font-medium">{script.fileName}</span> at{' '}
            <code className="text-xs break-all">{script.filePath}</code>
            <br />
            The file may have been moved or deleted. Remove it from the scripts
            list?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onKeep}>No, keep it</AlertDialogCancel>
          <AlertDialogAction onClick={onRemove}>
            Yes, remove
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
